<template>
    <v-card min-width="20vw" align="center" justify="center" outlined>
        <v-card-title>
            <v-list-item>
                <v-list-item-title v-if="!firstAsset"><h2>{{ $t('chooseAsset') }}</h2></v-list-item-title>
                <v-list-item-title v-else><h2>{{ $t('addFirstAsset') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action v-if="!firstAsset"><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <p v-if="firstAsset" v-html="$t('letsAddFirstAsset')"></p>
            <br v-if="firstAsset">
            <v-form v-model="valid">
                <v-autocomplete :label="$t('form_AddAsset.market.label')" :items="this.$store.state.markets" item-text="name" v-model="marketChoosed" @change="retrieveAssets" outlined/>
                <v-autocomplete :label="$t('form_AddAsset.asset.label')" :rules="assetRule" :items="assets" item-text="ticker" item-value="id" v-model="assetChoosed" outlined/>
                <v-btn @click="addAsset">{{ $t('add_AddAsset') }}</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';
    import Repository from '../../repositories/asset';

    export default {
        name: "AddAsset",
        data(){
            return {
                firstAsset: false,
                valid: false,
                assets: [],
                marketChoosed: '',
                assetChoosed: '',

                //rules
                assetRule: [
                    a => !!a || this.$t('alertMessage_AddAsset'),
                ],
            };
        },
        mounted() {
          this.firstAsset = (this.$store.state.user.assets.length === 0);
        },
        methods:{
            retrieveAssets(){
                Repository.assetsByMarket(this.marketChoosed).then((response) => {
                    this.assets = response.data;
                }).catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error.message);
                });
            },
            ...mapMutations(['setAssets']),
            addAsset(){
                if(this.valid) {
                    Repository.addAsset(this.assetChoosed).then(async (response) => {
                        if(response.status < 400)
                            await Repository.allAssetsOfUser().then((response) => { this.setAssets(response.data); });
                    });
                    this.closeWindow();
                }
                else
                    alert(this.$t('alertMessage_AddAsset'));
            },
            closeWindow(){
                this.$emit('closeWindow');
            }
        }
    }
</script>

<style scoped>

</style>

